import React from 'react';
export default function Help() {
  return (<div>Help content</div>);
}



// WEBPACK FOOTER //
// ./src/views/help/index.js